import NotificationMixin from './NotificationMixin';
import { formatDateTimeSecond,formatDateTime, formatDate } from '../utils/dates';

export default {
  mixins: [NotificationMixin],
  created() {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },
  computed: {
    item() {
      return this.find(decodeURIComponent(this.$route.params.id));
    }
  },
  methods: {
    del() {
      this.deleteItem(this.item).then(() => {
        if (this.item['name']) {
          this.showMessage(`${this.item['name']} ${this.$t('global.deleted')}`);
        } else {
          this.showMessage(`${this.item['@id']} ${this.$t('global.deleted')}`);
        }
        this.$router
          .push({ name: `${this.$options.servicePrefix}List` })
          .catch(() => {});
      });
    },
    editHandler(item) {
      this.$router.push({
        name: `${this.$options.servicePrefix}Update`,
        params: { id: item['@id'] }
      });
    },
    editSubHandler(item,prefix) {
      this.$router.push({
        name: `${prefix}Update`,
        params: { id: item['@id'] }
      });
    },
    showHandlerLink(item) {
      this.$router.push({
        name: `${item['@type']}Show`,
        params: { id: item['@id']}
      });
    },
    formatDateTime,
    formatDate,
    formatDateTimeSecond,
  },
  watch: {
    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
      }else {
        message && this.showError(message);
      }
    },
    deleteError(message) {
      message && this.showError(message);
    }
  }
};
